import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const getOverridenAgents = (
	agents: Agent[],
	agentIdFiltersOverride?: string[],
	agentDefaultIdOverride?: string,
): Agent[] => {
	const defaultOverrideAgentsIndex = agents.findIndex(
		(agent) => agentDefaultIdOverride === agent.id,
	);

	let overridenAgents: Agent[] = [];

	if (defaultOverrideAgentsIndex !== -1) {
		overridenAgents = agents.map((agent, index) => ({
			...agent,
			is_default: index === defaultOverrideAgentsIndex,
		}));
	} else {
		overridenAgents = agents;
	}

	if (Array.isArray(agentIdFiltersOverride)) {
		return overridenAgents.filter(
			(agent) => agentIdFiltersOverride?.includes(agent.id) || agent.is_default,
		);
	}

	return overridenAgents;
};
